import React from 'react';
import { cn } from '../../utils/cn';

/**
 * Composant Alert pour afficher des messages d'information
 * @param {Object} props - Propriétés de l'alerte
 * @param {ReactNode} props.children - Contenu de l'alerte
 * @param {string} props.type - Type d'alerte (success, error, warning, info)
 * @param {string} props.className - Classes CSS supplémentaires
 * @returns {ReactElement} Composant d'alerte
 */
const Alert = ({ children, type = 'info', className = '', ...props }) => {
  const baseClasses = 'relative w-full rounded-lg border p-4';

  const typeClasses = {
    success: 'border-green-200 bg-green-50 text-green-900 dark:border-green-800 dark:bg-green-950 dark:text-green-50',
    error: 'border-red-200 bg-red-50 text-red-900 dark:border-red-800 dark:bg-red-950 dark:text-red-50',
    warning: 'border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-50',
    info: 'border-blue-200 bg-blue-50 text-blue-900 dark:border-blue-800 dark:bg-blue-950 dark:text-blue-50',
  };

  const icons = {
    success: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
      </svg>
    ),
    error: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
      </svg>
    ),
    warning: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
      </svg>
    ),
    info: (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  };

  return (
    <div
      className={cn(
        baseClasses,
        typeClasses[type],
        className
      )}
      role="alert"
      {...props}
    >
      <div className="flex items-center gap-2">
        <span className="flex-shrink-0">
          {icons[type]}
        </span>
        <div className="flex-1">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Alert;
